import { fetchData } from 'utils';

export type ClientEmailData = {
  email: string;
};

export default async function getClientEmail(): Promise<ClientEmailData> {
  return await fetchData('/client/email');
}
